import React, { useContext } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "reactstrap";
import Flex from "../common/Flex";
import {
  faUpRightFromSquare,
  faPoll,
  faCloudUploadAlt,
  faTachometer,
  faChartBar,
  faCircleInfo,
  faMoneyCheckDollar,
  faChartColumn,
  faCloudArrowDown,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { set } from "lodash";
import AppContext from "../../context/Context";
import { faRocketchat } from "@fortawesome/free-brands-svg-icons";

const NavbarVerticalMenuItem = ({ route, icon }) => {
  const getIcon = (icon) => {
    // route.icon === "poll" ? faPoll : route.icon
    if (icon === "poll") return faPoll;
    else if (icon === "faCloudUploadAlt") return faCloudUploadAlt;
    else if (icon === "faTachometerAlt") return faTachometer;
    else if (icon === "faChartBar") return faChartBar;
    else if (icon === "circle-info") return faCircleInfo;
    else if (icon === "money-check-dollar") return faMoneyCheckDollar;
    else if (icon === "chart-column") return faChartColumn;
    else if (icon === "cloud-arrow-down") return faCloudArrowDown;
    else if (icon === "rocketchat") return faRocketchat;
    else return icon;
  };

  //  const chatUrl = `${process.env.PUBLIC_URL}/admin/Chatbox`;
  let type = "";
  const { loginUserDetails } = useContext(AppContext);
  if (loginUserDetails.is_partner === "1") {
    type = "user";
  } else {
    type = "admin";
  }

  const chatUrl = `${process.env.PUBLIC_URL}/${type}/Chatbox`;
  return (
    <Flex alignItems="center">
      {route.icon && (
        <span className="nav-link-icon">
          <FontAwesomeIcon icon={getIcon(route.icon)} />
        </span>
      )}
      {icon ? (
        <>
          {route.name === "API Status" && (
            <a
              href="https://apistatus.sikkasoft.com/"
              target="_blank"
              rel="noreferrer"
              // style={{ textDecoration: "none", color: "inherit" }}
            >
              {route.name}
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                style={{
                  padding: "1px",
                  marginLeft: "3px",
                  marginBottom: "1px",
                }}
              />
            </a>
          )}
          {route.name === "Tickets" && (
            <span
              className="cursor-pointer-css-for-nav-tab"
              style={{ color: "orange !important" }}
              onClick={() => {
                toast.warn(
                  "Please contact Sikka support to link support tickets."
                );
              }}
            >
              {route.name}
            </span>
          )}
          {route.name === "Ask Me..!" && (
            <a
              href={chatUrl}
              target="_blank"
              rel="noreferrer"
              // style={{ textDecoration: "none", color: "inherit" }}
            >
              {route.name}
            </a>
          )}
          {route.name === "API Documentation" && (
            <a
              href="https://apidocs.sikkasoft.com/#603347df-cf60-4fcd-ab4c-9e047b36756d"
              target="_blank"
              rel="noreferrer"
              // style={{ textDecoration: "none", color: "inherit" }}
            >
              {route.name}
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                style={{
                  padding: "1px",
                  marginLeft: "3px",
                  marginBottom: "1px",
                }}
              />
            </a>
          )}
          {route.name === "Writeback APIs" && (
            <a
              href="https://documenter.getpostman.com/view/1842814/TzCHCWFT"
              target="_blank"
              rel="noreferrer"
              // style={{ textDecoration: "none", color: "inherit" }}
            >
              {route.name}
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                style={{
                  padding: "1px",
                  marginLeft: "3px",
                  marginBottom: "1px",
                }}
              />
            </a>
          )}
          {route.name === "Practice Onboarding" && (
            <a
              href="https://documenter.getpostman.com/view/1842814/2s9YeAAuA4"
              target="_blank"
              rel="noreferrer"
              // style={{ textDecoration: "none", color: "inherit" }}
            >
              {route.name}
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                style={{
                  padding: "1px",
                  marginLeft: "3px",
                  marginBottom: "1px",
                }}
              />
            </a>
          )}
        </>
      ) : (
        <span style={{ color: "orange !important" }}>{route.name}</span>
      )}

      {!!route.badge && (
        <Badge
          color={route.badge.color || "soft-success"}
          pill
          className="ml-2"
        >
          {route.badge.text}
        </Badge>
      )}
    </Flex>
  );
};

NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape({
    icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default React.memo(NavbarVerticalMenuItem);
